(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["kyarna-black-homepage"] && !Shopify.designMode) return;
  try {
    
(function(){'use strict';if(typeof IntersectionObserver==='undefined')return;if(window.matchMedia('(prefers-reduced-motion: reduce)').matches)return;var observer=new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting){e.target.classList.add('kbh-in');observer.unobserve(e.target);}});},{rootMargin:'0px 0px -60px 0px',threshold:0.08});document.querySelectorAll('.kbh-scroll-reveal,.kbh-scroll-stagger').forEach(function(el){observer.observe(el);});})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
